import React, {Component} from "react";
import axios from "axios";
import { CategoryData } from "../components/CategoryData";
import { DetailArticle as ComponentDetailArticle } from "../components/DetailArticle";
import ReactLoading from "react-loading";
import PageNav from "../partials/PageNav";

class DetailTeam extends Component{

    state = {
        team : false,
        articles : [],
        article : false,
        categories : [],
        error : ""
    }

    async getUser (){
        let user = await axios.get('users/' + this.props.match.params.id)
       if(user.status == 200){
            this.setState({ team : user.data })
            this.getArticle(user.data.id)
        }
    }

    
    async getArticle (id){
        let article = await axios.get('articles/' +  id)
        if(article.status == 200){
            this.setState({ article : article.data })
        }
    }

    async getArticles (){
        let articles = await axios.get('articles')
        if(articles.status == 200){
            this.setState({ articles : articles.data })
        }
    }

    async getCategories (){
        let categories = await axios.get('categories')
        if(categories.status == 200){
            this.setState({ categories : categories.data })
        }
    }

    componentDidMount(){
        this.getUser()
        this.getArticles()
        this.getCategories()
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }
    
    render(){
        
        let pagenav =  this.state.team ?  PageNav( "profil " + this.state.team ? ( this.state.team.name ) : "profile" ,  "/articles/" + this.props.match.params.id,  "/logo192.png",   this.state.team ? (  " Profil " + this.state.team.name   ) : "profil",  this.state.team ? (  this.state.team?.userprofile?.profile?.name + " " + this.state.team.name ) : "profil") : "";
        return(
            
            <main id="main">
                <div>{ pagenav }</div>
                
                <section id="blog" className="blog">
                    <div className="container p-0" data-aos="fade-up">

                        <div className="row">
                            <div className="col-md-9">
                            {
                                this.state.article && (
                                    <div>
                                        <ComponentDetailArticle   article={ this.state.article } comment={ -1 } categories={ [] } />
                                    </div>
                                )
                            }
                            </div>
                            <div className="col-md-3">
                                <CategoryData categories={ this.state.categories } articles={ this.state.articles.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1 ).filter( data => data.comment != 3).slice(0, 5) } />
                            </div>
                        </div>
                    </div>
                </section>
            </main> 
        )
    }
}
export default DetailTeam;